<template>
    <form autocomplete="off" method="POST" class="mainForm" @submit.prevent="submit" ref="desktop_form" v-if="!isMobile">
            <div class="row m-1">
                <div class="col-xs-12 col-sm-3 p-1">
                    <div class="form-group">
                        <vue-select
                            label=""
                            :labelcolor="colors.secondary"
                            :primarycolor="colors.primary"
                            :options="dropdowns.tipiCantiere"
                            name="tipologia_id"
                            trackby="id"
                            :required="false"
                            :currentvalue="currentsearch.tipologia"
                            selectname="tipologia"
                            :allowEmpty="true"
                            placeholder="Seleziona il tipo di unità">
                        </vue-select>
                    </div>
                </div>
                <div class="col-xs-12 col-sm-3 p-1">
                    <div class="form-group">
                        <vue-select
                            label=""
                            :labelcolor="colors.secondary"
                            :primarycolor="colors.primary"
                            :options="dropdowns.comuni"
                            name="citta_id"
                            trackby="id"
                            :required="false"
                            :currentvalue="currentsearch.citta"
                            selectname="comune"
                            :allowEmpty="true"
                            placeholder="Seleziona comune">
                        </vue-select>
                    </div>
                </div>
                <div class="col-xs-12 col-sm-3 p-1">
                    <div class="form-group">
                        <vue-select
                            label=""
                            :labelcolor="colors.secondary"
                            :primarycolor="colors.primary"
                            :options="dropdowns.classi_energetiche"
                            name="classe_energetica"
                            :currentvalue="currentsearch.classe_energetica"
                            trackby="id"
                            :allowEmpty="true"
                            selectname="classe_energetica"
                            placeholder="Seleziona classe energetica">
                        </vue-select>
                    </div>
                </div>

                <div class="col-sm-2 col-xs-12 p-1">
                    <div class="form-group">
                        <button class="search-button">
                            <i class="fas fa-spinner fa-spin" v-if="isLoading"></i>
                            <span v-else>Cerca</span>
                        </button>
                    </div>
                </div>
            </div>
        </form>
</template>

<script>
    export default {
        props: ['dropdowns', 'currentsearch', 'colors', 'isLoading', 'isMobile'],
        methods: {
            submit(event) {
                this.$emit('submitsearch', new FormData(this.$refs.desktop_form));
            }
        }
    }
</script>